import { NextPage, NextPageContext } from "next";
import dynamic from "next/dynamic";
import Auth from "@layouts/Auth";
import { canonicalLink } from "@helpers/url";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { localeKey } from "@constants/locale-key";

const PageConfirmOTP = dynamic(
  () => {
    return import("@containers/ConfirmOTP/ConfirmOTP");
  },
  { ssr: false },
);

const ConfirmOTPPage: NextPage = () => {
  return (
    <Auth title="Lupa Password - OTP">
      <PageConfirmOTP />
    </Auth>
  );
};

export async function getStaticProps({ locale }: NextPageContext) {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? "id", localeKey)),
      title: "Lupa Password - OTP",
      description: "Masukkan kode OTP yang dikirimkan ke email atau nomor ponsel Anda",
      imageUrl: "https://storage-assurance-dev.mytens.id/assets/mytenscustomer/bglogin.png",
      canonical: canonicalLink("/lupa-password/konfirmasi-otp", locale),
    },
  };
}

export default ConfirmOTPPage;
